<div class="modal" *ngIf="isVisible">
  <div class="modal-content">
    <div class="header">
      Entity Wise Info:
      <span class="close" (click)="closeModal()" (keydown)="closeModal()">&times;</span>
    </div>
    <div class="modal-body">
      <div class="entity-wise-content-container">
        <div class="date-and-entity-selectors d-flex justify-content-between">
          <app-company-selector
            [showCompanyGroup]="true"
            (selectedCompany)="handleCompanySelectedValue($event)"></app-company-selector>
          <div class="month-from-to-selector">
            <div class="col-12 px-0">
              <label for="month">Month</label>
              <select
                class="form-select mt-2"
                [(ngModel)]="selectedMonth"
                (change)="onMonthChange($event.target.value)">
                <option *ngFor="let option of monthOptions" [value]="option.key">
                  {{ option.value }}
                </option>
              </select>
            </div>
            <div class="col-12 px-0 mt-2">
              <div class="row justify-content-end">
                <div class="col-6">
                  <div class="row mx-0">
                    <div class="col-12 align-self-center px-0">
                      <p class="mb-0">From</p>
                    </div>
                    <div class="col-12 align-self-center px-0 text-center">
                      <input type="date" class="form-control mt-2" [(ngModel)]="fromDate" (change)="dateSelection()" />
                    </div>
                  </div>
                </div>
                <div class="col-6">
                  <div class="row mx-0">
                    <div class="col-12 align-self-center px-0">
                      <p class="mb-0">To</p>
                    </div>
                    <div class="col-12 align-self-center px-0 text-center">
                      <input type="date" class="form-control mt-2" [(ngModel)]="toDate" (change)="dateSelection()" />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="entity-wise-content mt-4" *ngIf="entityWiseData?.statistics?.length > 0">
          <div
            *ngFor="let statistics of entityWiseData?.statistics; let idx = index"
            class="row mx-0 my-2"
            [ngClass]="classNames[idx]">
            <div class="col-md-8 col-12 left-cont-boxx">
              <h3>{{ statistics.type }}</h3>
              <h2>{{ statistics.completedPercentage }}%</h2>
              <div class="progress">
                <div
                  class="progress-bar"
                  role="progressbar"
                  [style.width.%]="statistics.completedPercentage"
                  [aria-valuenow]="statistics.completedPercentage"
                  aria-valuemin="0"
                  aria-valuemax="100"></div>
              </div>
            </div>
            <div class="col-md-2 col-6 text-center right-cont-boxx">
              <div class="bg-white">
                <h3>{{ statistics.totalCount }}</h3>
                <p>Count</p>
              </div>
            </div>
            <div class="col-md-2 col-6 text-center right-cont-boxx">
              <div class="bg-white">
                <h3>{{ statistics.completedCount }}</h3>
                <p>Completed</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
